(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-cart"]) return;
  try {
    
    (function($) {
    $.fn.inputFilter = function(inputFilter) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function() {
    if (inputFilter(this.value)) {
    this.oldValue = this.value;
    this.oldSelectionStart = this.selectionStart;
    this.oldSelectionEnd = this.selectionEnd;
    } else if (this.hasOwnProperty("oldValue")) {
    this.value = this.oldValue;
    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
    } else {
    this.value = "";
    }
    });
    };
    }(jQuery));

    $(document).ready(function(){

    $(".purchase-benefits,.checkout-btn").attr("disabled", "true");
    $("#po-number").blur(function(){
    if ( $(this).val() != "") {
    $(".purchase-benefits,.checkout-btn").removeAttr("disabled");
    } else {
    $(".purchase-benefits,.checkout-btn").attr("disabled", "true");        
    }
    });    
    $(".input-number-field").inputFilter(function(value) {
    return /^-?\d*[.,]?\d*$/.test(value); });
    });
    // Restricts input for each element in the set of matched elements to the given inputFilter.


    
  } catch(e) { console.error(e); }
})();
})();
